<template>
  <div>
    <slot />

    <TairoPanels />
  </div>
</template>
